<template>
  <div class="AppBar">
    <div id="nav" class="black">
      <router-link style="text-decoration: none; color: inherit;" to="/">
        <v-tooltip color="red darken-1" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="white" v-bind="attrs" v-on="on">fas fa-home</v-icon>
          </template>
          <span>Home</span>
        </v-tooltip>
      </router-link> |
      <router-link style="text-decoration: none; color: inherit;" to="/about">
        <v-tooltip color="red darken-1" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="orange darken-3" v-bind="attrs" v-on="on">fas fa-bullseye</v-icon>
          </template>
          <span>About</span>
        </v-tooltip>
      </router-link>
    </div>
  </div>
</template>
<script>
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@fortawesome/fontawesome-free/css/all.css'

export default {
  name: 'AppBar'
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}*/
</style>